import { StyleSheet } from 'react-native';
import React from "react";
import { GraphBookingPresenceDayChart, GraphBookingPresenceWeekChart, GraphCheckinTime, GraphTotalBookingsWeek } from 'components/management/molecules/graphs'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import GraphDateRange, { formatDateRange } from 'components/atoms/GraphDateRange'
import { getChartDateRange } from 'services/redux/management/reducers'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const RoomStatistics = ({ room }) => {
	
	const _graphDateRange = useSelector( state => {
		return getChartDateRange(state);
	} )
	
	const graphs = [
		<GraphCheckinTime
			dateRange={ formatDateRange( _graphDateRange ) }
			room={[
				room.guid
			]}
		/>,
		<GraphTotalBookingsWeek
			dateRange={ formatDateRange( _graphDateRange ) }
			room={[
				room.guid
			]}
		/>,
		<GraphBookingPresenceWeekChart
			dateRange={ formatDateRange( _graphDateRange ) }
			room={[
				room.guid
			]}
		/>,
		<GraphBookingPresenceDayChart
			dateRange={ formatDateRange( _graphDateRange ) }
			room={[
				room.guid
			]}
		/>,
	]
	
	return (
		<Grid>
			<Container>
				<Row>
					<Column>
						<GraphDateRange containerStyle={ staticStyles.graphDateRangeMarginTop0 } />
					</Column>
				</Row>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					{ _.map( graphs, graph => {
						return (
							<Row>
								<Column
									span={ 12 }>

									{ graph }
								</Column>
							</Row>
						);
					})}
				</VStack>
			</Container>
		</Grid>
	)
}

const staticStyles = StyleSheet.create({
	graphDateRangeMarginTop0: {
		marginTop: 0,
	},
});

export default RoomStatistics
